<div class="m-1 d-inline-flex">
  <select style="cursor: pointer" #groupBy (change)="groupBoardData(groupBy.value)" class="form-control w-auto pl-2">
    <option value="none">None</option>
    <option value="department">Department</option>
    <option value="projectManager">Project Manager</option>
  </select>
</div>
